import React from 'react';

const IntlContext = React.createContext({
  locale: 'en',
  messages: {}
});

export default IntlContext;



// WEBPACK FOOTER //
// ./src/universal/components/Intl/IntlContext.js